import React from "react";
import { Container } from "reactstrap";

import Banner from "../../../components/Banner";

const About = () => {
  return (
    <React.Fragment>
      <Banner title="회사소개" subtitle="About OverTheMoon" bg="banner2.jpg" />
      <div className="site-section">
        <Container>
          <div className="row mb-3">
            <div className="col-md-6">
              <h2>오버더문이란</h2>
              <p className="lead mx-auto desc">
                영국 명문대 출신의 강사들의 협력으로 만들어낸 영국/미국 등
                최상의 해외 명문대 입시 시스템을 가진 플랫폼입니다. 4차
                산업시대에 세계로 향하는 인재를 길러내는 오버더문에듀는 학생이
                진정으로 원하는 길이 무엇인지 함께 고민하고 최선을 다해 같이
                걸어가고자 한 사람 한 사람에게 꼭 맞는 교육프로그램을 연구하고
                실천하고 있습니다. 학생이 원하는 시간에 최고의 선생님을
                배치하고, 효율적인 시스템 관리를 더하여학생에게 꼭 맞는
                커리큘럼과 방향, 커뮤니티를 제공합니다. 아들이 처음 내딛던 발에
                환호성을 지르던 순간이 생각이 납니다. 처음으로 꿈을 펼치는
                발걸음을 내딛는 분들과 함께 환호성을 지르며 응원하는
                오버더문에듀가 되겠습니다.
              </p>
            </div>
            <div className="col-md-6">
              <img
                src={require("../../../assets/img/logo_with_text.png")}
                className="img-fluid"
                alt="ucas_official"
              />
            </div>
          </div>
          <hr />
          <div className="row mt-4">
            <div className="col-md-6">
              <p className="lead mx-auto desc">
                저희 오버더문 에듀컬리지/센터는 영국교육부 기관 중 하나인 UCAS
                (Universities and Colleges Admissions Service)가 공식적으로
                인증한 International College/Centre로서 영국입시 절차에 관한
                서비스에 대해 도움을 드리고 있습니다.
              </p>
              <p className="lead mx-auto desc">
                Officially Registered Centre (공식인증센터) 로서 학생들에게
                일반적인 원서 지원절차부터 Prediction Grades(공식예상점수),
                Reference(추천서), Personal Statement(자기소개서) 등에 대해
                전문적인 서비스 및 컨설팅을 제공해 영국대학에 진학시키고
                있습니다.
              </p>
              <p className="lead mx-auto desc">
                UCAS는 매월 저희 센터에 학생들이 필요로 하는 필수적인 정보들을
                제공하고 있으며 저희는 학생에게 필요한 전반적인 입시정보 및
                유학정보를 공유하고 있습니다. 입시요강이 불규칙적으로 바뀌는
                만큼, UCAS는 매해 학생 및 부모님들이 Officially Registered
                Centre (공식인증센터) 에게 정보를 문의하길 권고하고 있습니다.
              </p>
              <p className="mx-auto desc">
                *UCAS는 영국대학의 입학지원절차를 운영하는 것을 주된 역할으로
                하는 영국 기반 교육 조직 입니다.
              </p>
            </div>
            <div className="col-md-6">
              <img
                src={require("../../../assets/img/ucas_official.jpg")}
                className="img-fluid mb-4"
                alt="ucas_official"
              />
              <iframe
                title="ucas_adviser_widget"
                frameBorder="0"
                height="250"
                id="ucas_adviser_widget"
                scrolling="no"
                src="https://www.ucasdigital.com/widgets/advisers/ucas-adviser-widget.html"
                width="300"
              ></iframe>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default About;
